import { isEmpty } from 'lodash'
import moment from 'moment'

export const formatTime = (time, transformation) => {
  if (isEmpty(time) || isEmpty(transformation)) {
    return ''
  }
  return moment(time).local().format(transformation)
}
